export default __webpack_public_path__ + "static/media/modelo_importacao_contatos.4f52fdda.csv";